/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Binary pass/fail projector: pass -> 1.0, fail -> 5.0.
 */
export interface BinaryPassFailProjector {
  type?: 'binary_pass_fail';
}
